import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { nhsFooterTag } from '@ui/elementTags';
import { applyNhsGlobal } from '@ui/styles/applyNhsGlobal';
import footerStyles from '@ui/styles/nhs-subsets/nhs-footer.scss?inline';

export interface FooterLinkViewModel {
  id: 'homepage' | 'messages' | 'profile';
  label: string;
}

@customElement(nhsFooterTag)
export class NhsFooterComponent extends LitElement {
  @property({ attribute: false })
  public links: FooterLinkViewModel[] = [];

  protected createRenderRoot(): HTMLElement | ShadowRoot {
    return applyNhsGlobal(this, footerStyles);
  }

  public render() {
    return html`
      <footer class="nhsuk-footer" role="contentinfo">
        <div class="nhsuk-width-container">
          <div class="nhsuk-footer__meta">
            <h2 class="nhsuk-u-visually-hidden">Support links</h2>
            <ul class="nhsuk-footer__list">
              ${this.links.map((link) => html`
                <li class="nhsuk-footer__list-item">
                  <a class="nhsuk-footer__list-item-link" href="#" @click=${(event: Event) => this.handleClick(event, link.id)}>
                    ${link.label}
                  </a>
                </li>
              `)}
            </ul>
          </div>
        </div>
      </footer>
    `;
  }

  private handleClick(event: Event, id: FooterLinkViewModel['id']): void {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('footer-link-click', {
      bubbles: true,
      composed: true,
      detail: { id },
    }));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [nhsFooterTag]: NhsFooterComponent;
  }
}